import { Type } from 'class-transformer'
import { OutputBorders } from '@app/features/scope-overview/model/output-template.model'

const FIXED_ORDER: Record<string, number> = { COVER_PAGE: -2, BLANK_HEADER: -1, BLANK_FOOTER: 1000 }

export class OutputField {
  id!: number
  disabled!: boolean
  editable!: boolean
  headerRepeatable!: boolean
  footerRepeatable!: boolean
  outputFieldBorders!: any
  softDeleted!: boolean
  fieldType!: string
  name!: string
  content!: string
  order!: number
  index!: number
  mouseover!: boolean
  active!: boolean
  activeSection!: boolean
  showAlignment!: boolean
  editName!: boolean
  children!: OutputField[]
  @Type(() => OutputBorders) outputTemplateBorders!: OutputBorders

  get modifiedOrder(): number {
    return FIXED_ORDER[this.fieldType] ?? this.order
  }
}
